import {
  Bestellung,
  BstlArtikel,
  Bezahlart,
  LoadState,
  Terminart,
  BPAufgebenRequest,
  RemoteResult,
} from "mangdto"
import {
  BestellungPending,
  BestellungPending_Abholung as Abholung,
  BestellungPending_Sofortbestellung as Sofortbestellung,
  BestellungPending_Reservierung as Reservierung,
} from "mangdto"
import router from "@/router"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import RouteNames from "@/util/route_names"
import BaseLogic from "../base_logic"
import vuexStore from "@/store"

export default class BestaetigenLogic extends BaseLogic {
  bestaetigenLoadState: string = LoadState.Idle
  bestellung: Bestellung = null
  warenkorb: BstlArtikel[] = []
  terminart: string = null
  bezahlart: string = null
  agbAkzeptiert: boolean = false

  abholungData: Abholung
  reservierungDate: Reservierung
  sofortData: Sofortbestellung

  init() {
    this.mainLogic.bestellungPendingListeners.push(() => {
      var nbd = this.mainLogic.bestellungPending
      this.bezahlart = nbd.bezahlart

      this.warenkorb = nbd.artikelliste
      this.terminart = nbd.terminart

      if (this.terminart === Terminart.Abholung) {
        this.abholungData = nbd.abholung
      } else if (this.terminart === Terminart.Reservierung) {
        this.reservierungDate = nbd.reservierung
      } else if (this.terminart === Terminart.Sofortbestellung) {
        this.sofortData = nbd.sofort
      }
    })

    var nbd = this.mainLogic.bestellungPending
    this.bezahlart = nbd.bezahlart

    this.warenkorb = nbd.artikelliste
    this.terminart = nbd.terminart

    if (this.terminart === Terminart.Abholung) {
      this.abholungData = nbd.abholung
    } else if (this.terminart === Terminart.Reservierung) {
      this.reservierungDate = nbd.reservierung
    } else if (this.terminart === Terminart.Sofortbestellung) {
      this.sofortData = nbd.sofort
    }
  }

  agbAnzeigen() {
    router.push({ name: RouteNames.AGB })
  }

  bestellungBestaetigen() {
    if (this.bezahlart == Bezahlart.Paypal) {
      router.push({ name: RouteNames.NEU.TRINKGELD })
      return
    }

    this.bestaetigenLoadState = LoadState.Loading

    var request = new BPAufgebenRequest()
    request.bestellungId = vuexStore.state.user.identifier
    request.bezahlart = this.bezahlart

    Poster.postUser<RemoteResult<Bestellung>>(
      RestPaths.bestellungpendingAufgeben,
      request,
    )
      .then((response) => {
        if (response.data.success) {
          var dto = response.data.payload

          this.mainLogic.bestellung = dto
          this.mainLogic.bestellungPending = new BestellungPending()
          this.mainLogic.neueBestellung = false

          if (dto.bezahlart == Bezahlart.Paypal) {
            router.push({
              name: RouteNames.NEU.BEZAHLUNG_WEITERLEITEN,
              params: {
                bestellungId: dto.id,
              },
            })
            return
          }

          router.push({
            name: RouteNames.BESTELLUNG_PAGE.DETAILS,
            params: { bestellungId: dto.id },
          })
        } else {
          this.bestaetigenLoadState = LoadState.Error
        }
      })
      .catch(() => {
        this.bestaetigenLoadState = LoadState.Error
      })
  }
}
